module.exports = __webpack_public_path__ + "media/22.78185595.mp3";